import {
  LOOKUP_EMAIL_NO_ACCOUNT,
  LOOKUP_EMAIL_ID_EXISTS,
  LOOKUP_EMAIL_ACCOUNT_FOUND,
  LOOKUP_EMAIL_ADD_NAME,
  LOOKUP_EMAIL_ERROR,
  LOOKUP_EMAIL_ACCOUNT_SUSPENDED,
  RESET_EMAIL_LOOKUP_DATA,
} from '../constants'

const initialState = {
  emailId: '',
  lookupEmailData: {
    isAccountFound: false,
    doesIdExist: false,
    hasNoAccount: false,
    addName: false,
    isLookupEmailError: false,
    accountSuspended: false,
  },
  maskedCustomerName: '',
  profileId: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOOKUP_EMAIL_NO_ACCOUNT:
      return {
        ...state,
        emailId: action.response,
        lookupEmailData: {
          ...state.lookupEmailData,
          hasNoAccount: true,
        },
      }
    case LOOKUP_EMAIL_ID_EXISTS:
      return {
        ...state,
        emailId: action.response,
        lookupEmailData: {
          ...state.lookupEmailData,
          doesIdExist: true,
        },
      }
    case LOOKUP_EMAIL_ACCOUNT_FOUND:
      return {
        ...state,
        emailId: action.response.email,
        maskedCustomerName: action.response.maskedCustomerName,
        lookupEmailData: {
          ...state.lookupEmailData,
          isAccountFound: true,
        },
        profileId: action.response.profileId,
      }
    case LOOKUP_EMAIL_ADD_NAME:
      return {
        ...state,
        emailId: action.response.email,
        lookupEmailData: {
          ...state.lookupEmailData,
          addName: true,
        },
        profileId: action.response.profileId,
      }
    case LOOKUP_EMAIL_ERROR:
      return {
        ...state,
        lookupEmailData: {
          isAccountFound: false,
          doesIdExist: false,
          hasNoAccount: false,
          isLookupEmailError: true,
        },
      }
    case RESET_EMAIL_LOOKUP_DATA:
      return {
        ...state,
        lookupEmailData: {
          isAccountFound: false,
          doesIdExist: false,
          hasNoAccount: false,
          addName: false,
          isLookupEmailError: false,
        },
      }
    case LOOKUP_EMAIL_ACCOUNT_SUSPENDED:
      return {
        ...state,
        lookupEmailData: {
          ...state.lookupEmailData,
          accountSuspended: true,
        },
      }
    default:
      return state
  }
}
